/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { MasterZoneRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { MasterZone } from './master-zone.model';

@Injectable()
export class OfficePermissionsMasterZoneListBusinessService implements InitViewService {

  constructor(private masterZoneRest: MasterZoneRestService,
              private gridLayoutService: GridLayoutService,
  ) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('masterZonesWithoutFee'),
    };
  }

  findAllMasterZonesAsDataSource(): SlicedDataSource<MasterZone> {
    return this.masterZoneRest.getAllForView();
  }
}
